import { render, staticRenderFns } from "./VideoBoxModal.vue?vue&type=template&id=3cca9eea&scoped=true"
import script from "./VideoBoxModal.vue?vue&type=script&lang=js"
export * from "./VideoBoxModal.vue?vue&type=script&lang=js"
import style0 from "./VideoBoxModal.vue?vue&type=style&index=0&id=3cca9eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca9eea",
  null
  
)

export default component.exports